<template>
  <div class="index" :style="{ fontFamily: fonts }">
    <div class="empty"></div>
    <div class="text">{{ message }}</div>
  </div>
</template>

<script>
import { getDatas, getMeetModel } from "@/utils/request";
import { getUserIP } from "../utils/getIp.js";
const ipreg = /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/;
export default {
  data() {
    return {
      equipmentName: "",
      meetingId: "",
      ip: "",
      name: "",
      timer: null,
      fonts: "",
      message: "初始化页面中......",
      bgUrl:'',
      apkStatus: null
    };
  },
  created() {
    this.getMeetModels();
  },
  mounted() {
    // this.initPort();
    getUserIP(ip => {
      if (this.isValidIp(ip)) {
        this.ip = ip;
        this.getDatas();
        this.timer = setInterval(() => {
          this.getDatas();
        }, 9000);
      }
    });

    // this.initPort();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    //验证是否是ip地址
    isValidIp(e) {
      return ipreg.test(e);
    },
    getMeetModels() {
      getMeetModel().then(res => {
        if (Number(res.code) === 0) {
          this.fonts = res.data.fontStyle;
        }
      });
    },
    // ip和mac
    getDatas() {
      let params = {
        equipmentIP: this.ip
      };
      getDatas(params)
        .then(res => {
          console.log(res);
          if (res.code == 0) {
            this.equipmentName = res.data[0].equipmentName;
            this.meetingId = res.data[0].meetingId;
            this.name = res.data[0].name;
            this.bgUrl = res.data[0].photoUrl ? res.data[0].photoUrl : require('../assets/bg@2x.png')
            console.log(this.bgUrl)
            localStorage.setItem('bgUrl',this.bgUrl)
            this.apkStatus = res.data[0].apkStatus
            localStorage.setItem('apkStatus',this.apkStatus)
            this.$router.push({
              path: "/homePage",
              query: {
                equipmentName: this.equipmentName,
                meetingId: this.meetingId,
                meetingName: this.name
              }
            });
          } else {
            this.message = res.msg;
            // this.getDatas();
          }
        })
        .catch(res => {
          this.message = "网络请求失败,请稍后重试...";
        });
    }
  }
};
</script>

<style lang="less" scoped>
.index {
  // width: 100%;
  // height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: url(../assets/init-bg.png) no-repeat;
  background-size: 100% 100%;
  .empty {
    width: 100%;
    height: 45%;
  }
  .text {
    width: 100%;
    text-align: center;
    font-size: 80px;
    color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Initialize.vue